import {FC, ReactNode} from 'react';

interface ActionRowProps {
  children: ReactNode;
  accessory?: ReactNode;
}

/**
 * Lays out a registration panel's primary action with an optional accessory
 * (e.g. the mobile footer's Share button) aligned beside it. Renders the
 * action untouched when no accessory is given.
 */
export const ActionRow: FC<ActionRowProps> = ({children, accessory}) => {
  if (!accessory) return <>{children}</>;

  return (
    <div className="flex items-center gap-2">
      <div className="flex-1">{children}</div>
      {accessory}
    </div>
  );
};
